/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiHtmlSnippetProps } from './hei-html-snippet.props.autogenerated';

type IHeiHtmlSnippetData = {};

export interface IHeiHtmlSnippetViewProps extends IHeiHtmlSnippetProps<IHeiHtmlSnippetData> {}

/**
 *
 * HeiHtmlSnippet component
 * @extends {React.PureComponent<IHeiHtmlSnippetProps<IHeiHtmlSnippetData>>}
 */
class HeiHtmlSnippet extends React.PureComponent<IHeiHtmlSnippetProps<IHeiHtmlSnippetData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HeiHtmlSnippet;
